import { ReactNode } from "react"

type PageScaffoldProps = {
  children: ReactNode
}

export function PageScaffold({ children }: PageScaffoldProps) {
  return (
    <div className="relative z-10 flex min-h-screen flex-col bg-background">
      <main className="flex-1">{children}</main>
    </div>
  )
}
